export default function getEnv(key) {
  return window.env?.[key] || process.env[key];
}
